var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBuilding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.917 4.125a3.209 3.209 0 0 1 3.197 2.945l.011.263v29.792h3.208a1.375 1.375 0 0 1 .187 2.737l-.187.013H3.667a1.375 1.375 0 0 1-.187-2.737l.187-.013h.458V14.667a3.209 3.209 0 0 1 2.945-3.198l.263-.01 5.959-.001V7.333a3.209 3.209 0 0 1 2.945-3.197l.263-.011h17.417zM23.833 14.208h-16.5a.459.459 0 0 0-.446.354l-.012.105v22.458h7.333v-2.292a1.375 1.375 0 0 1 2.738-.186l.012.186v2.292h7.334V14.667a.459.459 0 0 0-.354-.447l-.105-.012zm10.084-7.333H16.5a.459.459 0 0 0-.446.353l-.012.105v4.125h7.791a3.209 3.209 0 0 1 3.198 2.946l.01.263v22.458h7.334V7.333a.459.459 0 0 0-.353-.446l-.105-.012zM21.083 27.958a1.375 1.375 0 0 1 .187 2.738l-.187.012h-11a1.375 1.375 0 0 1-.186-2.737l.186-.013h11zm0-5.5a1.375 1.375 0 0 1 .187 2.738l-.187.012h-11a1.375 1.375 0 0 1-.186-2.737l.186-.013h11zm0-5.5a1.375 1.375 0 0 1 .187 2.738l-.187.012h-11a1.375 1.375 0 0 1-.186-2.737l.186-.013h11z",
    fill: "#9EA2FA",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBuilding2);
export default __webpack_public_path__ + "static/media/icons-building-2.01647ac7e214d458dfab6ac7f9b7b1ad.svg";
export { ForwardRef as ReactComponent };